/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_EyebrowInputs */

const en_gc_editor_eyebrow = /** @type {(inputs: Gc_Editor_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your browser. Your workbook.`)
};

const zh_gc_editor_eyebrow = /** @type {(inputs: Gc_Editor_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的浏览器，你的工作簿。`)
};

/**
* | output |
* | --- |
* | "Your browser. Your workbook." |
*
* @param {Gc_Editor_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_eyebrow = /** @type {((inputs?: Gc_Editor_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_eyebrow(inputs)
	return zh_gc_editor_eyebrow(inputs)
});
export { gc_editor_eyebrow as "gc.editor.eyebrow" }